/**
 * Created by Andrey Popov on 26.10.2021
 */

const ExitExpeditionIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.exit_expedition_json,
        targets: "mainWorld",
        control: "ExitExpeditionIcon"
    });
};

ExitExpeditionIcon.prototype = Object.create(SideBarIcon.prototype);
ExitExpeditionIcon.prototype.constructor = ExitExpeditionIcon;

ExitExpeditionIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "ExitExpeditionIconClicked",
        actions: [
            function (f) {
                setTimeout(f, 300);
            },

            function (f) {
                cleverapps.meta.gotoMainLocation(f);
            }
        ]
    });
};

ExitExpeditionIcon.prototype.resetState = function () {
    this.available = !cleverapps.meta.getSelectedLocation().locationConfig.isMain;
    if (this.available) {
        this.setTitle(Messages.get("Exit"));

        const pocket = new Pocket();
        this.setAttention(!pocket.isEmpty());
    }
};
